<div class="drw-container">
  <div class="drw-header">
    <span class="drw-title">Create New Application</span>
    <button (click)="close()" mat-icon-button (keydown)="close()" [disabled]="isSubmitting">
      <mat-icon class="drw-close" viewBox="0 0 24 24" fill="none">close</mat-icon>
    </button>
  </div>

  <div class="drw-body">
    <div class="drw-content">
      <app-form [formGroup]="submitInvGroup" [formDefinition]="submitAppDefinition"></app-form>
    </div>

    <div class="drw-hint">
      <p class="hint-text">
        If you are looking for a public link you can publish to allow multiple borrowers to apply, visit the
        <a type="button" class="hint-settings-link" (click)="openSettingsImportantLinks()">settings menu</a>.
      </p>
    </div>
  </div>

  <div class="drw-footer">
    <button mat-flat-button color="accent" [disabled]="this.submitInvGroup.invalid || this.isSubmitting"
      (click)="submit()">
      @if (!isSubmitting) {
      <span>Send Application</span>
      }
      @if (isSubmitting) {
      <mat-spinner class="loading-spinner" diameter="20"></mat-spinner>
      }
    </button>
  </div>
</div>